var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-betslip-nav"},_vm._l((_vm.tabs),function(tab,idx){return _c('a',{key:idx,class:{
      'bto-sb-active': _vm.selectedTab === tab.id,
      'bto-sb-notactive': _vm.getComboLineCount > 1 && tab.id === _vm.COMBI_TYPE,
    },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.changeTab(tab.id)}}},[_vm._v(_vm._s(_vm.t(tab.translation)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }